"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheForTime = exports.CacheableResult = exports.createCacheKeyFromArgs = void 0;
const core_1 = require("../core");
const createCacheKeyFromArgs = (args) => args.reduce((cacheKey, arg) => (cacheKey += `_${typeof arg === 'object' ? JSON.stringify(arg) : `${arg}`}_`), '');
exports.createCacheKeyFromArgs = createCacheKeyFromArgs;
const CacheableResult = (cacheLiveTime, cache) => {
    return (0, exports.CacheForTime)(cacheLiveTime, cache, (data) => data.isSuccess);
};
exports.CacheableResult = CacheableResult;
const CacheForTime = (cacheLiveTime, cache, dataNeedCache) => {
    return (target, propertyKey, descriptor) => {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            return __awaiter(this, void 0, void 0, function* () {
                const key = (0, exports.createCacheKeyFromArgs)([propertyKey, args]);
                core_1.Log.info('Cache: ', 'Loading saved : ', key);
                const cachedObject = cache.getCached(key);
                if (cachedObject) {
                    core_1.Log.info('Cache: ', 'Key: ', key, 'Return cached objet: ', cachedObject);
                    return cachedObject;
                }
                core_1.Log.info('Cache: ', 'Key: ', key, 'Not cached object');
                core_1.Log.info('Cache: ', 'Calling fn: ');
                const result = yield originalMethod.apply(target, args);
                if (dataNeedCache(result)) {
                    core_1.Log.info('Cache: ', 'Key: ', key, 'value: ', result);
                    cache.setCached(key, result, cacheLiveTime);
                }
                else {
                    core_1.Log.info('Cache: ', 'Key: ', key, 'value: ', result, 'is an error, not cached');
                }
                return result;
            });
        };
    };
};
exports.CacheForTime = CacheForTime;
//# sourceMappingURL=utils.js.map